import { render, staticRenderFns } from "./FormItems.vue?vue&type=template&id=1ac61149&"
import script from "./FormItems.vue?vue&type=script&lang=ts&"
export * from "./FormItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports